var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"create-todo"}},[(_vm.todoForCreate)?_c('todo-form-list'):_c('a-result',{attrs:{"status":"warning","title":_vm.$t('todo.unableCreate')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }